import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';

const ROLES = {
  ADMIN: 'ADMIN',
  DATA_MANAGER: 'DATA_MANAGER',
  LOGISTICS_COORDINATOR: 'LOGISTICS_COORDINATOR',
  AREA_COORDINATOR: 'AREA_COORDINATOR',
  CLIENT: 'CLIENT',
};

const PERMISSIONS = {
  CREATE_PROJECTION: 'projection_add',
  EDIT_PROJECTION: 'projection_change',
  DELETE_PROJECTION: 'projection_delete',
  VIEW_PROJECTION: 'projection_view'
};

const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.CREATE_PROJECTION,
    PERMISSIONS.EDIT_PROJECTION,
    PERMISSIONS.DELETE_PROJECTION,
    PERMISSIONS.VIEW_PROJECTION
  ],
  [ROLES.DATA_MANAGER]: [
    PERMISSIONS.VIEW_PROJECTION
  ],
  [ROLES.LOGISTICS_COORDINATOR]: [
    PERMISSIONS.EDIT_PROJECTION,
    PERMISSIONS.VIEW_PROJECTION
  ],
  [ROLES.AREA_COORDINATOR]: [
    PERMISSIONS.EDIT_PROJECTION,
    PERMISSIONS.VIEW_PROJECTION
  ],
  [ROLES.CLIENT]: [
    PERMISSIONS.VIEW_PROJECTION
  ]
};

const usePermissions = () => {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasPermission = (permission) => {
    if (!user?.role?.name) return false;
    return ROLE_PERMISSIONS[user.role.name]?.includes(permission) || false;
  };

  const can = {
    createProjection: () => hasPermission(PERMISSIONS.CREATE_PROJECTION),
    editProjection: () => hasPermission(PERMISSIONS.EDIT_PROJECTION),
    deleteProjection: () => hasPermission(PERMISSIONS.DELETE_PROJECTION),
    viewProjection: () => hasPermission(PERMISSIONS.VIEW_PROJECTION)
  };

  return {
    loading,
    error,
    can,
    ROLES,
    PERMISSIONS
  };
};

export default usePermissions;
